import { useEffect, useState } from 'react'

const bundleName = (text: string) => /assets\/(index-[^"'\s]+\.js)/.exec(text)?.[1] || null

/**
 * Tells the user when a newer version of the app has been deployed while this tab was left open
 * (a long-lived tab keeps running the old code until it is reloaded). Checks on focus and every 5 minutes.
 */
export function UpdateBanner() {
  const [stale, setStale] = useState(false)

  useEffect(() => {
    const loaded = [...document.scripts].map((s) => bundleName(s.src)).find(Boolean) || null
    if (!loaded) return // dev server: scripts are not hashed
    let stopped = false
    const check = async () => {
      try {
        const res = await fetch('/', { cache: 'no-store' })
        const latest = bundleName(await res.text())
        if (!stopped && latest && latest !== loaded) setStale(true)
      } catch { /* offline — try again later */ }
    }
    const timer = window.setInterval(check, 5 * 60 * 1000)
    const onFocus = () => { void check() }
    window.addEventListener('focus', onFocus)
    void check()
    return () => { stopped = true; window.clearInterval(timer); window.removeEventListener('focus', onFocus) }
  }, [])

  if (!stale) return null
  return (
    <div role="alert" data-testid="update-banner" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: '#1f3a5f', color: '#fff', padding: '9px 14px', display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>
      <span>A new version of the app is available. Save what you are doing, then reload to use it.</span>
      <button type="button" className="btn-accent" style={{ padding: '4px 12px' }} onClick={() => window.location.reload()}>Reload now</button>
    </div>
  )
}
